import React from "react";
import styled from "styled-components";

const COLORS = {
  primary: {
    background: "#0065C0",
    text: {
      idle: "white",
      hover: "white",
      active: "white",
      disabled: "#6C757D",
    },
    border: "none",
  },
  secondary: {
    background: "#FFFFFF",
    text: {
      idle: "#004F96",
      hover: "#0065C0",
      active: "#004F96",
      disabled: "#ADB5BD",
    },
    border: {
      idle: "#CED4DA",
      hover: "#0065C0",
      active: "#004F96",
      disabled: "#CED4DA",
    },
  },
  ghost: {
    background: "transparent",
    text: {
      idle: "#004F96",
      hover: "#0065C0",
      active: "#004F96",
      disabled: "#ADB5BD",
    },
    border: "none",
  },
  danger: {
    background: "#EC2D30",
    text: {
      idle: "white",
      hover: "white",
      active: "white",
      disabled: "#6C757D",
    },
    border: "none",
  },
};

const Button = styled.button`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: ${({ width }) => width || "auto"};
  padding: ${({ $noPadding }) => ($noPadding ? "0" : "12px 24px")};
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  opacity: ${({ $state }) =>
    ({
      idle: 1,
      hover: 0.8,
      active: 0.6,
      disabled: 0.5,
    }[$state])};
  pointer-events: ${({ $state }) => ($state === "disabled" ? "none" : "auto")};

  background: ${({ $variant }) => COLORS[$variant]?.background};
  color: ${({ $isRemove, $variant, $state }) =>
    $isRemove ? "#EC2D30" : COLORS[$variant]?.text[$state]};
  border: ${({ $variant, $state }) => {
    if ($variant === "secondary") {
      return `1px solid ${COLORS[$variant].border[$state]}`;
    }
    return COLORS[$variant]?.border || "none";
  }};

  &:hover {
    opacity: ${({ $state }) => ($state === "idle" ? 0.8 : undefined)};
  }

  &:active {
    opacity: ${({ $state }) => ($state === "idle" ? 0.6 : undefined)};
  }
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  height: 100%;
  ${({ $position }) =>
    $position === "left" ? `margin-right: 8px;` : `margin-left: 8px;`}
`;

const IconButton = ({
  variant = "primary",
  state = "idle",
  icon,
  children,
  type = "button",
  width,
  iconPosition = "left",
  isRemove = false, // remove button prop to show the color differently
  noPadding = false, // padding around the button deciding prop
  ...props
}) => (
  <Button
    $variant={variant}
    $state={state}
    $isRemove={isRemove}
    $noPadding={noPadding}
    type={type}
    width={width}
    {...props}
  >
    {icon && iconPosition === "left" && (
      <IconWrapper $position="left">{icon}</IconWrapper>
    )}
    <span>{children}</span>
    {icon && iconPosition === "right" && (
      <IconWrapper $position="right">{icon}</IconWrapper>
    )}
  </Button>
);

export default IconButton;
